type MatchmakingLoadingStateProps = {
  currentLoadingTheme: { text: string; color: string };
  currentLoadingMessageIndex: number;
};

export const MatchmakingLoadingState = ({
  currentLoadingTheme,
  currentLoadingMessageIndex,
}: MatchmakingLoadingStateProps) => {
  return (
    <div className="space-y-8">
      <div className="flex items-center justify-center gap-4 py-8">
        <div className="relative flex-shrink-0">
          <svg
            className="animate-spin h-12 w-12"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            style={{ color: currentLoadingTheme.color }}
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
        </div>
        <div className="max-w-md">
          <p 
            key={currentLoadingMessageIndex}
            className="text-lg font-termina"
            style={{
              animation: 'fadeIn 0.5s ease-in-out',
              color: currentLoadingTheme.color
            }}
          >
            {currentLoadingTheme.text}
          </p>
        </div>
      </div>
    </div>
  );
};

